<div class="eap-container">
    <div class="top-row">
        <div class="name-container">
            <mat-icon
                data-cy="sys-status-printers-icon"
                svgIcon="status-indicator"
                [ngClass]="{
                    alarm_status: hasAlarms() && isReceivingData,
                    disconnected_status: !isReceivingData,
                    stable_status: !hasAlarms() && isReceivingData,
                }"
            />
            {{ "system-status.page-title.printers" | translate }}
            {{ " " + (index + 1) }}
        </div>
        <div class="location-container">
            <mat-icon svgIcon="location_on" />
            {{ printer.location }}
        </div>
    </div>
    <div class="status-container">
        <div
            class="status-wrapper"
            [ngClass]="{
                'alarm-font': getIcon(printer.run) === 'status-error',
            }"
        >
            {{ "system-status.printers.run" | translate }}
            <mat-icon
                *ngIf="isReceivingData"
                data-cy="sys-status-printers-run-icon"
                svgIcon="{{ getIcon(printer.run) }}"
                class="icon"
            />
            <div *ngIf="!isReceivingData" class="disconnected-line"></div>
        </div>
    </div>
</div>
